import Vue from 'vue';
import Router from 'vue-router';

import EmptyView from '@/views/EmptyView';
import LoginView from '@/views/LoginView';
import SettingsView from '@/views/settings/SettingsView';
import TeachersListView from '@/views/manage-teachers/TeachersListView';
import TeacherProfileView from '@/views/manage-teachers/TeacherProfile';
import DefaultCalendar from '@/views/my-schedule/CalendarView';

import reports from './reports';
import schedule from './schedule';
import classes from './classes';
import lessons from './lessons';
import authenticationBeforeRouting from './guards/authentication-before-routing';

Vue.use(Router);

const routerConfig = {
  mode: 'hash',
  routes: [
    {
      path: '/learners',
      name: 'learners',
      component: () =>
        import(
          /* webpackChunkName: 'manage-learners' */
          '@/views/manage-learners/ManageLearnersView'
        ),
      meta: {
        isTimeZoneSensitive: true,
        title: 'Manage Learners',
      },
    },
    {
      path: '/learners/:learnerId',
      name: 'learner_profile',
      component: () =>
        import(
          /* webpackChunkName: 'learner-profile' */
          '@/views/learner-profile/LearnerProfileView'
        ),
      props: true,
    },
    {
      path: '/manage-teachers',
      name: 'teachers',
      component: TeachersListView,
    },
    {
      path: '/manage-teachers/calendar/:orgId/:teacherHashEmail',
      name: 'manage_teachers_calendar',
      component: DefaultCalendar,
    },
    {
      path: '/manage-teachers/profile/:teacherHashEmail',
      name: 'manage_teachers_profile',
      component: TeacherProfileView,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/settings',
      name: 'my_settings',
      component: SettingsView,
    },
    ...reports,
    ...schedule,
    ...classes,
    ...lessons,
    {
      path: '/',
      name: 'root',
      component: EmptyView,
    },
  ],
};

const router = new Router(routerConfig);
router.beforeEach(authenticationBeforeRouting);
export default router;
